<div class="document-viewer">
  <div class="doc-header">
    <button type="button" class="btn btn-transparent mb-2" (click)="closeDocumentViewer()"><img
        src="assets/img/white-back.svg" alt="" class="ml-0 mr-2">BACK </button>
    <h4 class="document-title">
      <img *ngIf="isAudio" src="assets/img/audio-white-icon.svg" alt="" class="mr-2">
      <img *ngIf="isVideos" src="assets/img/video-white-icon.svg" alt="" class="mr-2">
      <img *ngIf="isDocuments" src="assets/img/document-white-icon.svg" alt="" class="mr-2">
      <img *ngIf="isPresentations" src="assets/img/presentations-white-icon.svg" alt="" class="mr-2">
      {{data?.item?.name}}
    </h4>

    <a *ngIf="isDownloadable" class="download" type='application/pdf' [href]="data.item.src" target="_blank" download><i class="fa fa-download"></i></a>

   

  </div>
  <div class="document-holder" [ngClass]="{'doc-error': isDocumentError}">
    <mat-progress-bar mode="indeterminate" *ngIf="!isDocumentLoaded"></mat-progress-bar>

    <ng-container *ngIf="isDocumentError">
      <p class="doc-err-msg">Unable to load the document. Please try again</p>
    </ng-container>
    <ng-container *ngIf="!isDocumentError">
      <ng-container *ngIf="isDocuments || isPresentations">
        <ngx-doc-viewer [url]="data.item.src" [viewer]="data.item.format == 'application/pdf'? 'google' : 'office'" style="width:100%;height:100%;"
          [disableContent]="'popout-hide'" (loaded)="documentLoaded()"></ngx-doc-viewer>
      </ng-container>
      <ng-container *ngIf="isVideos">
        <video width="100%" controls autoplay controlsList="nodownload" (loadeddata)="documentLoaded()"
          (error)="documentLoadError($event)">
          <source [src]="data.item.src" type="video/mp4">
        </video>
      </ng-container>
      <ng-container *ngIf="isAudio">
        <div class="audio-box">
          <audio width="100%" height="240" controls autoplay controlsList="nodownload" (loadeddata)="documentLoaded()"
            (error)="documentLoadError($event)">
            <source [src]="data.item.src" type="audio/mpeg">
          </audio>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>